import {Injectable, resource} from "@angular/core";
import {AmbientLight, DirectionalLight, Scene} from "three";
import {Color} from "three/src/math/Color";
import {Texture} from "three/src/textures/Texture";
import {CubeTexture} from "three/src/textures/CubeTexture";

@Injectable({providedIn: 'root'})
export class SceneService {

    constructor() {
    }

    public new(background?: Color | Texture | CubeTexture): Scene {

        const scene = new Scene();

        scene.background = background ?? null;


        const ambient = new AmbientLight(0xffffff, 0.5);
        scene.add(ambient);

        const directional = new DirectionalLight(0xffffff, 1.0);
        directional.position.set(10, 10, 10);
        scene.add(directional);

        return scene;
    }


}